import { ref, push, set, remove, update, onValue } from 'firebase/database';
import { database } from '../config/firebase';

/**
 * コンテンツ管理に関するFirebase操作を集約したサービス
 */
export const contentService = {
  /**
   * コンテンツ一覧を取得
   * @param {Function} callback データ受信時のコールバック関数
   * @returns {Function} unsubscribe関数
   */
  subscribeToContents: (callback) => {
    const contentsRef = ref(database, 'contents');
    return onValue(contentsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const contentList = Object.entries(data).map(([id, content]) => ({
          id,
          ...content,
          quizzes: content.quizzes
            ? Object.entries(content.quizzes).map(([qid, quiz]) => ({
                id: qid,
                ...quiz,
              }))
            : [],
        }));
        callback(contentList);
      } else {
        callback([]);
      }
    });
  },

  /**
   * 新しいコンテンツを追加
   * @param {Object} contentData コンテンツデータ
   * @returns {Promise<string>} 作成されたコンテンツのID
   */
  addContent: async (contentData) => {
    const contentRef = push(ref(database, 'contents'));
    await set(contentRef, {
      ...contentData,
      quizzes: {},
      timestamp: Date.now()
    });
    return contentRef.key;
  },

  /**
   * コンテンツを更新
   * @param {string} contentId コンテンツID
   * @param {Object} updates 更新データ
   * @returns {Promise<void>}
   */
  updateContent: async (contentId, updates) => {
    const contentRef = ref(database, `contents/${contentId}`);
    await update(contentRef, {
      ...updates,
      updatedAt: Date.now()
    });
  },

  /**
   * コンテンツを削除
   * @param {string} contentId コンテンツID
   * @returns {Promise<void>}
   */
  deleteContent: async (contentId) => {
    const contentRef = ref(database, `contents/${contentId}`);
    await remove(contentRef);
  },

  /**
   * コンテンツの初期データを作成
   * @param {Object} params パラメータオブジェクト
   * @returns {Object} コンテンツデータ
   */
  createContentData: ({ 
    title, 
    subject, 
    randomizeQuizzes = false, 
    freeNavigation = false,
    timeLimitPerQuestion = 0,
    timeLimitPerContent = 0,
    answerRevealMode = 'immediate',
    quickAnswerMode = 'standard'
  }) => {
    const contentData = {
      title,
      subject,
      randomizeQuizzes,
      freeNavigation,
      answerRevealMode,
      quickAnswerMode,
    };

    if (freeNavigation) {
      contentData.timeLimitPerContent = timeLimitPerContent;
      contentData.timeLimitPerQuestion = 0;
    } else {
      contentData.timeLimitPerQuestion = timeLimitPerQuestion;
      contentData.timeLimitPerContent = 0;
    }

    return contentData;
  }
}; 